// Version : 0.0.5
// Author : VISHNU
// LastEdit : KARTHEESWARAN
// MODFIED DATA : 13-08-2025
import { makeApiCall } from '../../../_common/api.utils';
import { FIN_API_URL } from '../../../const';

/** ***************** ADD GST TYPE DETAILS START *********************** */
export const GSTTypeDetailsAdd = (addData: any) => {
	const data = {
		AddGstTypeDataToken: addData,
	};
	const url = `${FIN_API_URL}addGSTTypeDetails`;
	return makeApiCall(url, data);
};
/** ***************** ADD GST TYPE DETAILS END *********************** */

/** ***************** UPDATE GST TYPE DETAILS START *********************** */
export const GSTTypeDetailsUpdate = (updateData: any) => {
	const data = {
		UpdateGstTypeDataToken: updateData,
	};
	const url = `${FIN_API_URL}updateGSTTypeDetails`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE GST TYPE DETAILS END *********************** */

/** ***************** GET GST TYPE LIST START *********************** */
export const GSTTypeListGet = (listData: any) => {
	const data = {
		GetGSTTypeListToken: listData,
	};
	const url = `${FIN_API_URL}getGSTTypeList`;
	return makeApiCall(url, data);
};
/** ***************** GET GST TYPE LIST END *********************** */

/** ***************** FETCH GST TYPE DETAILS START *********************** */
export const GSTTypeDetailsFetch = (fetchData: any) => {
	const data = {
		FetchGstTypeDetailsToken: fetchData,
	};
	const url = `${FIN_API_URL}fetchGSTTypeDetails`;
	return makeApiCall(url, data);
};
/** ***************** FETCH GST TYPE DETAILS END *********************** */

/** ***************** DELETE GST TYPE DETAILS START *********************** */
export const GSTTypeDetailsDelete = (deleteData: any) => {
	const data = {
		DeleteGstTypeDetailsToken: deleteData,
	};
	const url = `${FIN_API_URL}deleteGSTTypeDetails`;
	return makeApiCall(url, data);
};
/** ***************** DELETE GST TYPE DETAILS END *********************** */
